import React, { useEffect, useState } from 'react';

// Generate a random ASCII string of given length
function generateRandomAsciiString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+=-';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

const barCount = 50; // How many bars (columns) to show

const App: React.FC = () => {
  const [bars, setBars] = useState<string[]>([]);

  useEffect(() => {
    // Update all bars every 1 second
    const intervalId = setInterval(() => {
      const newBars = Array.from({ length: barCount }, () => {
        // Choose a random length for each bar (height)
        const length = Math.floor(Math.random() * 50) + 1; 
        return generateRandomAsciiString(length);
      });
      setBars(newBars);
    }, 300);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div
      style={{
        position: 'fixed', // fills entire browser viewport
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#000', 
        display: 'flex',
        alignItems: 'flex-end', // bar “bases” line up at the bottom
        justifyContent: 'center',
        fontFamily: 'monospace',
        padding: '1rem',
      }}
    >
      {bars.map((barString, i) => {
        // Use an HSL shift to give each bar a different color, left-to-right
        const color = `hsl(${(i * 360) / barCount}, 100%, 50%)`;

        return (
          <div
            key={i}
            style={{
              display: 'flex',
              flexDirection: 'column-reverse',
              alignItems: 'center',
              color,
              transition: 'height 0.5s ease',
              margin: '0 10px'
            }}
          >
            {/* Render one text “row” per character, stacking from bottom up */}
            {Array.from(barString).map((char, idx) => (
              <span key={idx}>{char}</span>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default App;
